

import { useState } from 'react';
import axios from 'axios';
import loadCashfreeScript from './loadCashfreeScript';
import styles from './subscription-plans.module.css';
import Notification from '../shared/Notification';

const PLANS = [
  { key: '1_month',  label: '1 Month',  price: 7,  popular: false },
  { key: '3_months', label: '3 Months', price: 299, popular: false },
  { key: '6_months', label: '6 Months', price: 599, popular: true  },
  { key: '1_year',   label: '1 Year',   price: 999, popular: false },
];

const SubscriptionPlans = () => {
  const [loading, setLoading] = useState(null);
  const [error,   setError]   = useState(null);
  const [notification, setNotification] = useState(null);

  const handleSubscribe = async (planKey) => {
    setLoading(planKey);
    setError(null);
    try {
      // 1. Load Cashfree script
      const loaded = await loadCashfreeScript();
      if (!loaded) throw new Error('Payment SDK failed to load.');

      // 2. Create order on backend
      const { data } = await axios.post(
        '/api/applicant/payment/create-order',
        { subscriptionType: planKey },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      // 3. Init Cashfree
      // const cashfree = await window.Cashfree({ mode: 'sandbox' }); // 'production' for live
      const cashfree = await window.Cashfree({ mode: 'production' }); // 'production' for live

      // 4. Open checkout popup (UPI + QR + Card shown automatically)
      const result = await cashfree.checkout({
        paymentSessionId: data.payment_session_id,
        redirectTarget:   '_modal',
      });

      if (result.error) {
        throw new Error(result.error.message || 'Payment failed.');
      }

      // 5. Verify on backend
      const verify = await axios.post(
        '/api/applicant/payment/verify',
        { order_id: data.order_id },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      if (verify.data.success) {
        setNotification('Subscription activated successfully!');
        // optional: window.location.reload() or navigate('/dashboard')
      } else {
        setError(verify.data.message || 'Verification failed.');
      }

    } catch (err) {
      // console.error(err);
      setError(err?.response?.data?.message || err.message || 'Something went wrong.');
    }

    setLoading(null);
  };
  const testCreateOrder = async () => {
  try {
    const { data } = await axios.post(
      '/api/applicant/payment/create-order',
      { subscriptionType: '1_month' },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    // console.log('✅ Order created:', data);
  } catch (err) {
    // console.log('❌ Error123:', err.response?.data.message);
  }
};
  const handleCloseNotification = () => {
    setNotification(null);
  }

  return (
    <div className={styles.subscriptionPlans}>
      {error && (
        <div className={styles.errorBanner}>
          ⚠️ {error}
        </div>
      )}
      {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
      {/* <button onClick={testCreateOrder}>Test Create Order</button> */}


      <div className={styles.planGrid}>
        {PLANS.map((plan) => (
          <div
            key={plan.key}
            // className={`plan-card ${plan.popular ? 'popular' : ''}`}
            className={styles.planCard}
          >
            {/* {plan.popular && <span className="popular-badge">Most Popular</span>} */}

            <h3>{plan.label}</h3>
            <p className={styles.price}>₹{plan.price}</p>
            <p className={styles.upiNote}>UPI · QR · Card</p>

            <button className={styles.buyButton}
              onClick={() => handleSubscribe(plan.key)}
              disabled={!!loading}
            >
              {loading === plan.key ? 'Redirecting...' : 'Buy Now'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPlans;